// extracted by mini-css-extract-plugin
export default {"cabecalho":"Header_cabecalho__lLxwi","imgLogo":"Header_imgLogo__m4e8c"};